<div class="container-fluid p-3 bg-amber-50">
  <div class="bg-white rounded-md  border-2 border-blue-900 border-gray-300 px-4 py-2 sm:p-6 mb-4">
    <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
      <div class="flex gap-3">

        <div class="flex-1">
          <h4 class="text-xl sm:text-2xl font-bold text-slate-800 mb-1">
            {{stepDetails?.name}}
          </h4>

          <h5 class="text-base sm:text-lg text-blue-600 font-semibold mb-3">
            [{{ proposalName }}]
          </h5>


        </div>
        <div>

          <span class="inline-flex items-center px-3 py-1.5 border-2 rounded-full text-sm font-bold transition-all"
            [ngClass]="{
                          'bg-slate-100 text-slate-700 border border-slate-500': stepDetails?.step_status == 0,
                          'bg-emerald-100 text-emerald-700 border border-emerald-500': stepDetails?.step_status == 'approved',
                          'bg-amber-100 text-amber-700 border border-amber-500': stepDetails?.step_status == 'recommended',
                          'bg-blue-100 text-blue-700 border border-blue-500': stepDetails?.step_status == 'initiated'
                        }">
            <span class="w-2 h-2 rounded-full mr-2 animate-pulse" [ngClass]="{
                            'bg-slate-500': stepDetails?.step_status == 0,
                            'bg-emerald-500': stepDetails?.step_status == 'approved',
                            'bg-amber-500': stepDetails?.step_status == 'recommended',
                            'bg-blue-500': stepDetails?.step_status == 'initiated'
                          }"></span>
            {{ stepDetails?.step_status == 0 ? " PENDING" : (stepDetails?.step_status | uppercase) }}
          </span>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="flex flex-wrap items-center gap-2">
        <button (click)="generatePDF()"
          class="inline-flex items-center px-4 py-2.5 bg-white border-2 border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50 hover:border-slate-400 transition-all duration-200 font-medium text-sm shadow-sm hover:shadow">
          <i class="pi pi-file-pdf mr-2"></i> PDF
        </button>



        <ng-container *ngIf="stepDetails?.can_edit">
          <button (click)="routeConfig.emit({isRouteConfig: true})"
            class="inline-flex items-center px-4 py-2.5 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:bg-slate-300 disabled:cursor-not-allowed transition-all duration-200 font-medium text-sm shadow-sm hover:shadow-md">
            <i class="pi pi-save mr-2"></i> Save/Forward/Route Config
          </button>
        </ng-container>
      </div>
    </div>
  </div>
  <hr class="my-3" />


  <div class="mb-6 flex gap-2 overflow-x-auto pb-2">
    <button *ngFor="let name of vendorNames" (click)="onVendorChange(name)"
      [ngClass]="selectedVendor === name ? 'bg-blue-900 text-white shadow-lg' : 'bg-white text-slate-600 border'"
      class="px-6 py-2.5 rounded-full font-bold transition-all duration-200 whitespace-nowrap text-sm">
      <i class="pi pi-user mr-2"></i> {{ apiData[name]?.[0]?.vendor?.company_name }}
    </button>
  </div>

  <div *ngIf="selectedVendor" class="animate-fade-in">
    <div
      class="bg-white border border-slate-200 mb-4 rounded-lg overflow-hidden shadow-sm transition-all hover:border-blue-300">

      <div class="flex items-center justify-between px-3 py-2 bg-slate-50 border-b border-slate-200">
        <div class="flex items-center">
          <span class="w-8 h-8 rounded bg-blue-100 text-blue-600 flex items-center justify-center mr-2 text-base">
            <i class="pi pi-building"></i>
          </span>
          <span class="font-semibold text-slate-800 text-sm">
            {{ apiData[selectedVendor]?.[0]?.vendor?.company_name }}
            <span class="text-blue-600 ml-2 text-xs">- {{ stepDetails?.name }}</span>
          </span>
        </div>
        <span class="bg-blue-50 text-blue-700 px-2 py-0.5 rounded-full text-xs border border-blue-100 font-medium">
          Connected Person: {{ selectedVendor }}
        </span>
      </div>

      <div class="px-4 py-3">
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-2">

          <div class="flex items-center gap-2 py-1">
            <label class="font-medium text-slate-700 text-xs flex-1">Technically Completed</label>
            <input type="checkbox" [disabled]="!stepDetails?.can_edit"
              [ngModel]="apiData[selectedVendor]?.[0]?.technical_phase"
              (ngModelChange)="apiData[selectedVendor][0].technical_phase = $event" name="technical_phase"
              class="w-5 h-5 accent-blue-500 text-white cursor-pointer" />
          </div>

          <div class="flex items-center gap-2 py-1">
            <label class="font-medium text-slate-700 text-xs flex-1">Financially Completed</label>
            <input type="checkbox" [disabled]="!stepDetails?.can_edit"
              [ngModel]="apiData[selectedVendor]?.[0]?.financial_phase"
              (ngModelChange)="apiData[selectedVendor][0].financial_phase = $event" name="financial_phase"
              class="w-5 h-5 accent-blue-500 text-white cursor-pointer" />
          </div>

          <div class="flex items-center gap-2 py-1">
            <label class="font-bold text-xs text-slate-500 uppercase w-2/3">Actual Reimbursed (INR)</label>
            <div class="relative flex-1">
              <span class="absolute left-2 top-2.5 text-xs text-slate-400 font-bold">₹</span>
              <input type="number" [disabled]="!stepDetails?.can_edit"
                [ngModel]="apiData[selectedVendor]?.[0]?.disbursed_amount"
                (ngModelChange)="apiData[selectedVendor][0].disbursed_amount = $event" name="disbursed_amount"
                class="w-full pl-7 pr-2 py-2 border border-slate-200 rounded focus:border-blue-500 outline-none text-sm font-semibold" />
            </div>
          </div>

          <div class="flex items-center gap-2 py-1">
            <label class="font-bold text-xs text-slate-500 uppercase w-2/3">Actual Closed Date</label>
            <input type="date" [readonly]="!stepDetails?.can_edit" [ngModel]="apiData[selectedVendor]?.[0]?.actual_date"
              (ngModelChange)="apiData[selectedVendor][0].actual_date = $event" name="actual_date"
              class="w-full px-2 py-2 border border-slate-200 rounded focus:border-blue-500 outline-none text-sm" />
          </div>

          <div class="flex items-center gap-2 py-1 opacity-75">
            <label class="font-bold text-xs text-slate-500 uppercase w-2/3">Expected Date (WBS)</label>
            <input type="date" [ngModel]="apiData[selectedVendor]?.[0]?.wbs_date"
              (ngModelChange)="apiData[selectedVendor][0].wbs_date = $event" name="wbs_date" readonly
              class="w-full px-2 py-2 bg-slate-100 border border-slate-200 rounded cursor-not-allowed text-sm font-medium" />
          </div>

          <div class="flex items-center gap-2 py-1 opacity-75">
            <label class="font-bold text-xs text-slate-500 uppercase w-2/3">Disbursed (WBS)</label>
            <div class="relative flex-1">
              <span class="absolute left-2 top-2.5 text-xs text-slate-400 font-bold">₹</span>
              <input type="number" [ngModel]="apiData[selectedVendor]?.[0]?.wbs_amount"
                (ngModelChange)="apiData[selectedVendor][0].wbs_amount = $event" name="wbs_amount" readonly
                class="w-full pl-7 pr-2 py-2 bg-slate-100 border border-slate-200 rounded cursor-not-allowed text-sm font-medium" />
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
  <div class="bg-white border rounded-lg shadow p-4 mt-6">

  <!-- HEADER -->
  <div class="flex justify-between items-center mb-3">

    <h3 class="text-lg font-semibold">
      Work Breakdown Structure
    </h3>

    <div class="flex gap-2">

      <!-- ADD VERSION -->
    <button
(click)="toggleVersion()"
class="bg-blue-600 text-white px-4 py-2 rounded-md text-sm">

{{ isNewVersionAdded ? 'Remove New Version' : 'Add New Version' }}

</button>

      <!-- SAVE -->
      <button
        *ngIf="isNewVersionAdded"
        (click)="saveVersions()"
        class="bg-green-600 text-white px-4 py-2 rounded-md text-sm">

        Save Versions

      </button>

    </div>

  </div>

  <!-- TABLE -->
  <div class="w-full overflow-x-auto">

    <table class="min-w-max border text-sm">

      <!-- HEADER -->
      <thead class="bg-slate-100">

        <tr>

          <th rowspan="2" class="border px-3 py-2">Milestone</th>
          <th rowspan="2" class="border px-3 py-2">Deliverables Guideline</th>
          <th rowspan="2" class="border px-3 py-2">Sub Deliverables</th>
          <th rowspan="2" class="border px-3 py-2">Major Tasks</th>

          <!-- VERSION HEADER -->
          <ng-container *ngIf="data?.length">

           <th *ngFor="let i of [].constructor(maxVersions); let idx = index" colspan="4">
  Version {{ idx + 1 }}
</th>

          </ng-container>

        </tr>

        <!-- VERSION SUB HEADER -->
        <tr>

          <ng-container *ngIf="data?.length">

           <ng-container *ngFor="let i of [].constructor(maxVersions)">
  <th>Subtasks</th>
  <th>Duration</th>
  <th>Start Date</th>
  <th>End Date</th>
</ng-container>

          </ng-container>

        </tr>

      </thead>

      <!-- BODY -->
      <tbody>

        <tr *ngFor="let row of data; let r = index">

          <!-- FIXED COLUMNS (ALWAYS DISABLED) -->

          <td class="border px-2 py-1">
            <input
              [(ngModel)]="row.milestone"
              class="w-full border rounded px-2 py-1 bg-gray-100"
              readonly />
          </td>

          <td class="border px-2 py-1">
            <input
              [(ngModel)]="row.deliverable"
              class="w-full border rounded px-2 py-1 bg-gray-100"
              readonly />
          </td>

          <td class="border px-2 py-1">
            <input
              [(ngModel)]="row.subDeliverable"
              class="w-full border rounded px-2 py-1 bg-gray-100"
              readonly />
          </td>

          <td class="border px-2 py-1">
            <input
              [(ngModel)]="row.majorTask"
              class="w-full border rounded px-2 py-1 bg-gray-100"
              readonly />
          </td>

          <!-- VERSION COLUMNS -->

          <ng-container *ngFor="let version of (row.versions || []); let vi = index">

            <!-- SUBTASK -->
            <td class="border px-2 py-1">
              <input
                [(ngModel)]="version.subtask"
                class="w-full border rounded px-2 py-1"
                placeholder="Subtask"
                [readonly]="isVersionLocked" />
            </td>

            <!-- DURATION -->
            <td class="border px-2 py-1">
              <input
                type="number"
                [(ngModel)]="version.duration"
                class="w-full border rounded px-2 py-1"
                placeholder="Weeks"
                [readonly]="isVersionLocked" />
            </td>

            <!-- START DATE -->
            <td class="border px-2 py-1">

              <p-calendar
                [(ngModel)]="version.start"
                dateFormat="yy-mm-dd"
                showIcon="true"
                appendTo="body"
                [disabled]="isVersionLocked"
                class="w-full">

              </p-calendar>

            </td>

            <!-- END DATE -->
            <td class="border px-2 py-1">

              <p-calendar
                [(ngModel)]="version.end"
                dateFormat="yy-mm-dd"
                showIcon="true"
                appendTo="body"
                [disabled]="isVersionLocked"
                class="w-full">

              </p-calendar>

            </td>

          </ng-container>

        </tr>

      </tbody>

    </table>

  </div>

</div>



  <div class="bg-amber-50 border-2 border-gray-300 mb-6 rounded transition-all duration-200 hover:shadow-md">
    <div (click)="isDocumentUploadsOpen = !isDocumentUploadsOpen"
      class="flex items-center justify-between p-2.5 cursor-pointer bg-blue-950 text-white transition-all duration-200">
      <h3 class="text-lg font-semibold  flex items-center">
        <span class="w-8 h-8 rounded-lg bg-green-100 text-green-600 flex items-center justify-center mr-3 text-sm">
          <i class="pi pi-paperclip"></i>
        </span>
        {{ lableBoject[stepDetails?.code] || 'Upload Supporting Documents' }}
      </h3>
      <i class="pi transition-transform duration-200"
        [ngClass]="isDocumentUploadsOpen ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
    </div>
    <div *ngIf="isDocumentUploadsOpen" class="p-1 space-y-4 border-t border-slate-100 animate-fade-in">

      <app-upload-document [isEditable]="stepDetails.can_edit"> </app-upload-document>
    </div>
  </div>


 

</div>